<template>
  <div>

    <!-- Form modal -->
    <modalWindow
      v-show="pskFormToggle"
      @close="pskFormToggle = false; selectedPsk = {};"
      width="860"
      position="edge"
    >
      <div class="titlebar">Overdrachtsformulier</div>
      <div class="viewport">
        <pskForm
          :currentPsk="{
            instellingNaam: selectedPsk.institution_name,
            instellingNaamOmschrijving: selectedPsk.institution_name_description,
            overdrachtType: selectedPsk.type,
            iban: selectedPsk.iban,
            polisnummer: selectedPsk.polis_number,
          }"
          :intake="{
            persoonsData: [
              {
                voorletters: selectedPsk.initials,
                tussenvoegsel: selectedPsk.infix,
                achternaam: selectedPsk.surname,
              }
            ],
            goalData: { type: selectedPsk.goal_type}
          }"
          :email="selectedPsk.email"
          :port="selectedPsk.port"
        />
      </div>
      <div class="modalfooter">
        <span
          v-if="
            `${location}`.indexOf('http://') === -1 && `${location}`.indexOf('https://') === -1
          "
        >
          Printen is alleen mogelijk vanuit de site
        </span>
        <button style="float:right" @click="windowPrint" v-else>
          Printen <awesomeIcon icon="print" />
        </button>
      </div>
    </modalWindow>

    <!-- Note modal -->
    <modalWindow
      width="400"
      v-if="changeNote"
      @close="changeNote = false; note = ''; selectedPsk = {}"
    >
      <div class="titlebar">Overdracht notitie</div>
      <div class="inset">
        <div class="flex-container flex-grow">
          <textarea
            v-model="note"
            placeholder="Overdracht notitie..."
            rows="8"
            autofocus
          />
        </div>
        <button
          :class="[note ? '' : 'disabled']"
          @click="note ? savePskNote(selectedPsk) : ''"
        >
          Opslaan
        </button>
      </div>
    </modalWindow>

    <!-- Expiration date modal -->
    <modalWindow
      width="400"
      v-if="changeExpirationDate"
      @close="changeExpirationDate = false; expirationDate = ''; selectedPsk = {}"
    >
      <div class="titlebar">Expiratiedatum</div>
      <div class="inset">
        <div class="flex-container flex-grow">
          <customInput
            v-model="expirationDate"
            type="date"
            label="Expiratie datum"
          />
        </div>
        <button
          :class="[expirationDate ? '' : 'disabled']"
          @click="expirationDate ? savePskExpirationDate(selectedPsk) : ''"
        >
          Opslaan
        </button>
      </div>
    </modalWindow>

    <!-- Mail modal -->
    <pskMail
      v-if="pskMailModal"
      :selectedPsk="transferForMail"
      @close="pskMailModal = false"
    />

    <div class="row menubar" style="display: flex;justify-content: space-between">
      <button
        class="dropdown-button"
        @click="toggleFilters"
        :title="`Filters ${filters ? 'verbergen' : 'tonen'}`"
      >
        <awesomeIcon icon="filter"/>
      </button>
      <input
        type="text"
        v-model.lazy="search"
        placeholder="Zoeken"
        class="searchbar"
        title="Zoeken op port, intake, gebruiker, polis, IBAN, instelling"
        v-show="!filters"
        style="flex:1"
        @keyup.enter="clearInputs('generalSearch')"
      />
      <button
        @click="clearInputs('generalSearch')"
        class="search-button"
        v-show="!filters"
      >
        <awesomeIcon icon="search"/>
      </button>
      <button
        :class="[exportTotal > 0 ? '' : 'disabled']"
        @click="exportTransfers"
      >
        <awesomeIcon icon="download" /> Export ({{ exportTotal }})
      </button>

      <div class="dropdown nowrap multi-dropdown" style="float:right">
        <button class="dropdown-button" @click="institutionDropdown = true">
          <awesomeIcon icon="sort" />
          Instellingen
          ({{ selectedInstitutions.length }})
        </button>
        <div
          class="dropdown-bg"
          v-if="institutionDropdown"
          @click="
            institutionDropdown = false;
            getPskList(true);
          "
        />
        <ul class="dropdown-list" v-if="institutionDropdown">
          <li
            class="dropdown-deselect"
            @click="selectedInstitutions = ['Alle instellingen']"
          >
            <span :class="selectedInstitutions.length ? '' : 'grey'">
              Alle ({{ selectedInstitutions.length }}) actieve verwijderen
            </span>
          </li>
          <li
            v-for="(institution, index) in institutions"
            :key="index"
            @click="toggleInstitutions(institution)"
            :title="(selectedInstitutions.includes(institution))
                ? 'Verwijderen'
                : 'Toevoegen'
              "
          >
          <div class="dropdown-checkbox checkbox-green">
            <awesomeIcon :icon="selectedInstitutions.includes(institution)
                ? 'check-square'
                : 'fa-regular fa-square'
              "/>
          </div>
          <span :class="selectedInstitutions.includes(institution) ? 'checkbox-green' : ''">
            {{ institution }}
          </span>
          </li>
        </ul>
      </div>

      <inputDropdown
        :array="groups"
        v-model="view"
        :cb="generalDropdownCB"
        :defaultIndex="6"
        align="right"
      />

    </div>

    <div class="filters menubar" ref="filters" :class="filters ? 'active' : ''">
      <div class="filters-inner">
        <div class="input">
          <span>Adviseur</span>
          <inputSuggest
            :array="advisors"
            v-model="currentAdvisor"
            :clearable="true"
            clearedDisplayValue="Adviseur"
            :scroll="true"
            :defaultIndex="-1"
            :cb="generalDropdownCB"
            type="text"
            class="userIdInput"
            width="190px"
            ref="managerInput"
            :roles="[2, 7, 8, 9, 10]"
          />
        </div>
        <div class="triple-filter">
          <div class="triple-name">10 werkdagen verstreken sinds laatste mail</div>
          <div class="triple-filter-holder">
            <div
              v-for="(name) in tenWorkdaysTriple"
              :key="name"
              @click="tenWorkdays = name;getPskList(true)"
              :class="tenWorkdays === name ? 'active' : ''"
            >
              {{ name }}
            </div>
          </div>
        </div>
        <div class="input buttons">
          <button @click="clearInputs()">
            Wissen
          </button>
          <button @click="getPskList()">
            <awesomeIcon icon="sync"/>
          </button>
          <button @click="search = '';getPskList(true)">
            <awesomeIcon icon="search"/>
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="transfers !== null && transfers.length"
      class="card"
    >
      <table width="100%">
        <thead class="table-legend">
          <tr>
            <th width="10%">Intake / port</th>
            <th>Gebruiker</th>
            <th title="Polisnummer/IBAN, instelling naam" width="20%">Polis(iban) / inst.</th>
            <th>Type / bedrag</th>
            <th title="Polisblad">Polis.</th>
            <th title="Overdrachtsformulier">Overdr.</th>
            <th title="Ondertekend">Ondert.</th>
            <th v-if="view !== 'opgesteld' && view !== 'ondertekend'">Exp. datum</th>
            <th v-if="view !== 'opgesteld'">Mail</th>
            <th v-if="view !== 'opgesteld'">PSK</th>
            <th></th>
          </tr>
        </thead>
        <tr
          v-for="(transfer, index) in transfers"
          :key="index"
        >

          <td>
            #{{ transfer.intake }} <br />
            <span class="grey">{{ transfer.port || '-' }}</span>
          </td>

          <td>
            {{ transfer.initials || '' }} {{ transfer.infix || ''}} {{ transfer.surname || '' }}
          </td>

          <td>
            {{ transfer.polis_number ? transfer.polis_number : transfer.iban }} <br />
            <span class="grey">
              {{ transfer.institution_name === 'Anders'
                ? transfer.institution_name_description
                : transfer.institution_name
              }}
            </span>
          </td>

          <td>
            {{ transfer.type === 'psk2' ? 'Overig' : transfer.type }} <br />
            <span class="grey">
              €{{ formatPrice(transfer.amount, true) }},-
            </span>
          </td>

          <td
            v-if="filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-polis`
                )
            ).length < 0
            ">
            <awesomeIcon icon="times" color="red"/>
          </td>
          <td v-else>
            <span v-for="(file, fileIndex) in filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-polis`
                ),
              )"
              @click="download(transfer.intake, filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-polis`
                ),
              )[fileIndex].path)"
              :key="fileIndex"
            >
              <awesomeIcon
                class="green"
                style="cursor: pointer"
                :title="`${filter(
                  transfer.files,
                  (o) => o.path.includes(
                    `overdrachten-${Number(transfer.psk_index)}-polis`
                  ),
                )[0].path.substring(18 + prefix.length)}`"
                icon="eye"
              />
            </span>
          </td>

          <td>
            <span
              v-if="
                transfer.institution_name !== 'ASR'
                && (
                  transfer.type === 'psk2'
                  || filter(
                    transfer.files,
                    (o) => o.path.includes(
                      `overdrachten-${Number(transfer.psk_index)}-polis`
                    )
                  ).length > 0
                )
              "
              @click="loadPsk(transfer)"
            >
              <awesomeIcon
                class="green"
                style="cursor: pointer"
                title="Overdrachtsformulier"
                icon="eye"
              />
            </span>
          </td>

          <td
            v-if="filter(
              transfer.files,
              (o) => o.path.includes(
                `overdrachten-${Number(transfer.psk_index)}-ondertekend`
              )
              ).length > 0
              && (
                transfer.type === 'psk2'
                || filter(
                  transfer.files,
                  (o) => o.path.includes(
                    `overdrachten-${Number(transfer.psk_index)}-polis`
                  )
                ).length > 0
              )
            "
          >
            <span v-for="(file, fileIndex) in filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-ondertekend`
                ),
              )"
              @click="download(transfer.intake, filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-ondertekend`
                ),
              )[fileIndex].path)"
              :key="fileIndex"
            >
              <awesomeIcon
                class="green"
                style="cursor: pointer"
                :title="`${filter(
                  transfer.files,
                  (o) => o.path.includes(
                    `overdrachten-${Number(transfer.psk_index)}-ondertekend`
                  ),
                )[0].path.substring(18 + prefix.length)}`"
                icon="eye"
              />
            </span>
          </td>
          <td
            v-else-if="
              transfer.type === 'psk2'
              || filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-polis`
                )
              ).length > 0
            "
          >
            <customInput
              style="background: none !important"
              type="addFile"
              :prefix="`overdrachten-${Number(transfer.psk_index)}-ondertekend`"
              :validation="['notrequired']"
              :fileDelete="false"
              :intakeId="transfer.intake"
              :cb="getPskList"
            />
          </td>
          <td v-else></td>

          <td v-if="view !== 'opgesteld' && view !== 'ondertekend'">
            {{ transfer.expiration_date
              ? new Date(transfer.expiration_date).toLocaleDateString()
              : ''
            }}
            <awesomeIcon
              @click="addExpirationDate(transfer)"
              style="cursor: pointer"
              size="lg"
              title="Expiratiedatum"
              :icon="transfer.expiration_date ? 'calendar-check' : 'calendar'"
            />
          </td>

          <td
            v-if="
              filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-ondertekend`
                )
              ).length > 0
            "
            @click="openPskMail(transfer)"
          >
            <awesomeIcon
              v-if="!transfer.mail_user"
              style="cursor: pointer"
              icon="envelope"
              title="Nog geen mail verstuurd"
            />
            <awesomeIcon
              v-else
              style="cursor: pointer"
              :title="
                `${transfer.reminder_mail_user
                  ? 'Reminder-mail'
                  : 'Mail'
                } verstuurd op ${transfer.reminder_mail_date
                    ? new Date(transfer.reminder_mail_date).toLocaleString()
                    : new Date(transfer.mail_date).toLocaleString()
                } door ${transfer.reminder_mail_user
                    ? filter(users,{ id: transfer.reminder_mail_user })[0].email
                    : filter(users,{ id: transfer.mail_user })[0].email
                }`
              "
              :icon="transfer.reminder_mail_user ? `envelope-open-text` : `envelope-open`"
            />
          </td>

          <td
            v-if="filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-akkoord`
                )
            ).length > 0
              && filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-ondertekend`
                )
              ).length > 0
            "
          >
            <span
              v-for="(file, fileIndex) in filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-akkoord`
                ),
              )"
              @click="download(transfer.intake, filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-akkoord`
                ),
              )[fileIndex].path)"
              :key="fileIndex"
            >
              <awesomeIcon
                class="green"
                style="cursor: pointer"
                :title="`${filter(
                  transfer.files,
                  (o) => o.path.includes(
                    `overdrachten-${Number(transfer.psk_index)}-akkoord`
                  ),
                )[0].path.substring(18 + prefix.length)}`"
                icon="eye"
              />
            </span>
          </td>
          <td
            v-else-if="
              filter(
                transfer.files,
                (o) => o.path.includes(
                  `overdrachten-${Number(transfer.psk_index)}-ondertekend`
                )
              ).length > 0
            "
          >
            <customInput
              style="background: none !important"
              type="addFile"
              :prefix="`overdrachten-${Number(transfer.psk_index)}-akkoord`"
              :validation="['notrequired']"
              :fileDelete="false"
              :intakeId="transfer.intake"
              :cb="getPskList"
            />
          </td>

          <td>
            <awesomeIcon
              @click="addNote(transfer)"
              style="cursor: pointer"
              size="lg"
              :title="transfer.message ? transfer.message : 'Notitie'"
              :icon="transfer.message ? 'comment-dots' : 'comment'"
            />
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalTransfers"
        :resultsPerPage="maxPerPage"
      />
    </div>

    <div v-else-if="transfers !== null" class="noresults">
      <span>Geen resultaten</span>
    </div>

    <div v-else class="loader" />
  </div>
</template>

<script>
import {
  find, sumBy, filter, findIndex,
} from 'lodash-es';
import FileSaver from 'file-saver';
import pskForm from './intake/pskForm';
import pskMail from './pskMail';

export default {
  name: 'AdminTransfers',
  components: {
    pskForm,
    pskMail,
  },
  data() {
    return {
      tenWorkdays: 'Alles',
      tenWorkdaysTriple: [
        'Alles',
        'Ja',
        'Nee',
      ],
      transferForMail: {},
      tooltipText: '',
      pskMailModal: false,
      exportTotal: 0,
      currentAdvisor: null,
      advisors: [],
      users: [],
      institutionDropdown: false,
      selectedInstitutions: ['Alle instellingen'],
      search: '',
      filters: false,
      note: '',
      changeNote: false,
      expirationDate: '',
      changeExpirationDate: false,
      transfers: null,
      totalTransfers: null,
      prefix: 'psk',
      view: 'opgesteld',
      groups: [],
      pskMail: {},
      selectedPsk: {},
      location: window.location,
      pskFormToggle: false,
      maxPerPage: 10,
      currentPage: 0,
      bankNames: [
        { label: 'ABN Amro Bank', value: 'ABN' },
        { label: 'ACE Europe Life Limited', value: 'ACE' },
        { label: 'AEGON Bank', value: 'AEGON' },
        { label: 'Allianz Nederland Levensverzekering', value: 'Allianz' },
        { label: 'Amersfoortse Levensverzekeringmaatschappij', value: 'Amersfoortse' },
        { label: 'Argenta Spaarbank', value: 'Argenta' },
        { label: 'ASR Bank', value: 'ASR' },
        { label: 'Avéro Achmea', value: 'AvéroAchmea' },
        { label: 'Bâloise Vie Luxembourg S.A.', value: 'Baloise' },
        { label: 'BLG Wonen', value: 'BLG' },
        { label: 'Brand New Day Bank', value: 'BrandNewDay' },
        { label: 'Centraal Beheer Achmea', value: 'CentraalBeheerAchmea' },
        { label: 'Conservatrix', value: 'Conservatrix' },
        { label: 'Cordares Levensverzekeringen', value: 'Cordares' },
        { label: 'Credit Life AG', value: 'CreditLifeAG' },
        { label: 'DELA Natura- en Levensverzekeringen', value: 'DELA' },
        { label: 'Doelbeleggen', value: 'DB' },
        { label: 'FBTO', value: 'FBTO' },
        { label: 'FlexGarant Assuradeuren B.V.', value: 'FlexGarant' },
        { label: 'Goudse Levensverzekeringen', value: 'GoudseLevensverzekeringen' },
        { label: 'ING Bank', value: 'ING' },
        { label: 'Interpolis', value: 'Interpolis' },
        { label: 'Klaverblad Levensverzekering', value: 'Klaverblad' },
        { label: 'Leidsche Verzekering Maatschappij', value: 'Leidsche' },
        { label: 'Monuta Verzekeringen', value: 'Monuta' },
        { label: 'Nationale-Nederlanden Bank', value: 'NationaleNederlanden' },
        { label: 'Ohra Levensverzekeringen', value: 'Ohra' },
        { label: "Onderlinge Levensverzekering-Maatschappij 's-Gravenhage'", value: 'OnderlingeLevensverzekering' },
        { label: 'Quantum Leben AG', value: 'Quantum' },
        { label: 'Rabobank Nederland', value: 'Rabobank' },
        { label: 'Regiobank', value: 'Regiobank' },
        { label: 'Robein leven', value: 'Robein' },
        { label: 'Scildon', value: 'Scildon' },
        { label: 'SNS', value: 'SNS' },
        { label: 'SRLEV', value: 'SRLEV' },
        { label: 'Universal Leven', value: 'UniversalLeven' },
        { label: 'Van Lanschot Bankiers', value: 'VanLanschotBankiers' },
        { label: 'Waard Verzekeringen', value: 'Waard' },
        { label: 'WestlandUtrecht Bank', value: 'westlandUtrecht' },
        { label: 'Anders', value: 'Anders' },
      ],
    };
  },
  created() {
    // Reading cookies
    if (this.readCookie('pskFilterBrands')) {
      this.selectedInstitutions = this.readCookie('pskFilterBrands').split(',');
    }
    if (this.readCookie('pskFilterAdvisor')) {
      this.currentAdvisor = Number(this.readCookie('pskFilterAdvisor'));
    }
    if (this.readCookie('pskFilterTenWorkdays')) {
      this.tenWorkdays = this.readCookie('pskFilterTenWorkdays');
    }

    this.getAdvisors();
    this.sdk.getUsersQuick((usersResponse) => {
      this.users = usersResponse.data;
    });
    this.getPskList(true);
  },
  watch: {
    currentPage() {
      this.getPskList();
    },
  },
  computed: {
    institutions() {
      const list = ['Alle instellingen'];
      const bankNames = filter(this.bankNames, (o) => o.value !== 'DB');
      for (let i = 0; i < bankNames.length; i += 1) {
        list.push(bankNames[i].value);
      }
      return list;
    },
  },
  methods: {
    filter,
    filterBuilder(viewFilter = false) {
      const filterArray = [];
      if (viewFilter) {
        filterArray.push(`status eq ${this.view}`);
      }
      if (this.search) {
        filterArray.push(`search contains ${this.search}`);
        this.createCookie('pskFilterSearch', this.search);
      } else {
        this.eraseCookie('pskFilterSearch');
      }

      if (!this.selectedInstitutions.includes('Alle instellingen') && this.selectedInstitutions.length !== 0) {
        filterArray.push(`institution in ${this.selectedInstitutions.join(',')}`);
        this.createCookie('pskFilterBrands', this.selectedInstitutions);
      } else {
        this.eraseCookie('pskFilterBrands');
      }

      if (this.currentAdvisor) {
        filterArray.push(`advisor eq ${this.currentAdvisor}`);
        this.createCookie('pskFilterAdvisor', this.currentAdvisor);
      } else {
        this.eraseCookie('pskFilterAdvisor');
      }

      if (this.tenWorkdays !== 'Alles') {
        const date = new Date();
        date.setDate(date.getDate() - 14);
        if (this.tenWorkdays === 'Ja') {
          filterArray.push(`lastMailed lt ${date.toISOString()}`);
        } else {
          filterArray.push(`lastMailed eqgt ${date.toISOString()}`);
        }
        this.createCookie('pskFilterTenWorkdays', this.tenWorkdays);
      } else {
        this.eraseCookie('pskFilterTenWorkdays');
      }

      return filterArray.join(';');
    },
    removeFile(file) {
      this.$store.state.confirm.toggle({
        text: 'Wilt u dit bestand verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteIntakeFile(
              this.pskMail.intake,
              file,
              (response) => {
                if (response.status === 200) {
                  this.pskMail = {};
                  this.pskMailModal = false;
                  this.getPskList();
                } else {
                  // error
                }
              },
            );
          }
        },
      });
    },
    downloadFile(file) {
      this.sdk.getIntakeFile(this.pskMail.intake, file);
    },
    uploadFilesChanged(e) {
      this.uploadFiles(e.target.files.length);
    },
    uploadFiles() {
      this.sdk.addFileIntake(
        `overdrachten-${Number(this.pskMail.psk_index)}-pskmail`,
        this.pskMail.intake,
        this.$refs.files.files,
        (response) => {
          if (response.status === 200) {
            // success
            this.tooltipText = 'We hebben uw bestanden ontvangen.';
          } else {
            this.tooltipText = 'Fout met uploaden. Wij accepteren alleen afbeeldingen en pdf bestanden.';
          }
        },
      );
    },
    openPskMail(transfer) {
      this.pskMailModal = true;
      this.transferForMail = transfer;
    },
    exportTransfers() {
      if (this.exportTotal < 1) {
        return;
      }
      let exportTransfers = [];
      this.sdk.getPskList((response) => {
        if (response.status === 200) {
          exportTransfers = response.data.results;
          const lineArray = [];
          lineArray.push(
            'Vragenlijst;Portefeuille;Polis;IBAN;Gebruiker;Status;Bedrag;Instelling;E-maildatum;Expiratiedatum;Notitie',
          );
          exportTransfers.forEach((psk) => {
            const client = `${psk.initials || ''} ${psk.infix || ''} ${psk.surname || ''}`;
            let mailDate = '';
            if (psk.mail_date) {
              mailDate = psk.mail_date;
            }
            if (psk.reminder_mail_date) {
              mailDate = psk.reminder_mail_date;
            }
            lineArray.push(
              `${psk.intake || ''};${psk.port || ''};${psk.polis_number || ''};${psk.iban || ''};${client};${psk.status};${this.formatPrice(psk.amount || 0)};${psk.institution_name_description ? psk.institution_name_description : psk.institution_name};${mailDate !== '' ? new Date(mailDate).toISOString().split('T')[0] : ''};${psk.expiration_date ? new Date(psk.expiration_date).toISOString().split('T')[0] : ''};${psk.message || ''}`,
            );
          });
          const file = new File([lineArray.join('\n')], 'Export-psk-list.csv', {
            type: 'text/csv;charset=utf-8',
          });
          FileSaver.saveAs(file);
        } else {
          exportTransfers = [];
        }
      }, this.filterBuilder(), '', -1);
    },
    getAdvisors() {
      let filterArray = [];
      filterArray.push('role eqgt 7');
      filterArray = filterArray.join(';');
      this.sdk.getUserIds((response) => {
        if (response.status === 200) {
          this.advisors = [];

          for (let i = 0; i < response.data.results.length; i += 1) {
            this.advisors.push({
              label: response.data.results[i].name,
              value: response.data.results[i].id,
            });
          }
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filterArray, 0, 100);
    },
    getGroups() {
      this.sdk.getPskGroups((response) => {
        this.groups = [
          {
            label: 'Opgesteld (0 / 0)',
            rightLabel: '€ 0 / 0',
            value: 'opgesteld',
            totalValue: 0,
            totalValueFiltered: 0,
            totalRowsFiltered: 0,
          },
          {
            label: 'Ondertekend (0 / 0)',
            rightLabel: '€ 0 / 0',
            value: 'ondertekend',
            totalValue: 0,
            totalValueFiltered: 0,
            totalRowsFiltered: 0,
          },
          {
            label: 'Verstuurd (0 / 0)',
            rightLabel: '€ 0 / 0',
            value: 'verstuurd',
            totalValue: 0,
            totalValueFiltered: 0,
            totalRowsFiltered: 0,
          },
          {
            label: 'Afgerond (0 / 0)',
            rightLabel: '€ 0 / 0',
            value: 'afgerond',
            totalValue: 0,
            totalValueFiltered: 0,
            totalRowsFiltered: 0,
          },
          {
            rightLabel: '0 polissen - totaal € 0 / 0',
          },
        ];
        for (let i = 0; i < response.data.length; i += 1) {
          const index = findIndex(this.groups, { value: response.data[i].status });
          if (index !== -1) {
            this.groups[index].label = `${response.data[i].status} (0 / ${response.data[i].totalRows})`;
            this.groups[index].rightLabel = `€ 0 / ${this.formatPrice(response.data[i].totalValue, true)}`;
            this.groups[index].value = response.data[i].status;
            this.groups[index].totalValue = response.data[i].totalValue;
            this.groups[index].totalRows = response.data[i].totalRows;
            this.groups[index].totalRowsFiltered = 0;
            this.groups[index].totalValueFiltered = 0;
          }
        }
        this.sdk.getPskGroups((response2) => {
          for (let i = 0; i < response2.data.length; i += 1) {
            const index = findIndex(this.groups, { value: response2.data[i].status });
            this.groups[index].label = this.groups[index].label.replace(/\b0\b/, response2.data[i].totalRows);
            this.groups[index].rightLabel = this.groups[index].rightLabel.replace(/\b0\b/, this.formatPrice(response2.data[i].totalValue, true));
            this.groups[index].totalRowsFiltered = response2.data[i].totalRows;
            this.groups[index].totalValueFiltered = response2.data[i].totalValue;
          }
          if (find(this.groups, { value: this.view }).totalRowsFiltered === 0) {
            for (let i = 0; i < this.groups.length; i += 1) {
              if (this.groups[i].totalRowsFiltered > 0) {
                this.view = this.groups[i].value;
                this.getPskList();
                break;
              }
            }
          }
          this.exportTotal = sumBy(this.groups, (group) => group.totalRowsFiltered);
          this.groups[this.groups.length - 1].rightLabel = `${
            this.formatPrice(sumBy(this.groups, (group) => group.totalRowsFiltered), true)
          } / ${
            sumBy(this.groups, (group) => group.totalRows)
              ? this.formatPrice(sumBy(this.groups, (group) => group.totalRows), true)
              : 0
          } polissen - totaal € ${
            this.formatPrice(sumBy(this.groups, (group) => group.totalValueFiltered), true)
          } / ${
            this.formatPrice(sumBy(this.groups, (group) => group.totalValue), true)
          }`;
        }, this.filterBuilder());
      });
    },
    chooseGroup(group) {
      this.view = group;
      this.getPskList(true);
    },
    generalDropdownCB() {
      this.currentPage = 0;
      this.getPskList(true);
    },
    toggleInstitutions(institution) {
      if (institution === 'Alle instellingen') {
        this.selectedInstitutions = [institution];
        return;
      }
      if (this.selectedInstitutions.includes('Alle instellingen')) {
        this.selectedInstitutions.splice(this.selectedInstitutions.indexOf('Alle instellingen'), 1);
      }
      if (this.selectedInstitutions.includes(institution)) {
        this.selectedInstitutions.splice(this.selectedInstitutions.indexOf(institution), 1);
      } else {
        this.selectedInstitutions.push(institution);
      }

      if (this.selectedInstitutions.length === 0) {
        this.selectedInstitutions = ['Alle instellingen'];
      }
    },
    clearInputs(origin) {
      if (origin !== 'generalSearch') {
        this.search = '';
      }
      this.currentAdvisor = null;
      this.selectedInstitutions = ['Alle instellingen'];
      this.getPskList(true);
    },
    toggleFilters() {
      this.filters = !this.filters;

      if (this.filters) {
        if (this.search) {
          this.search = '';
          this.getPskList(true);
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.filters.style.overflow = 'visible';
          }, 150);
        });
      } else {
        this.$refs.filters.style.overflow = '';
      }
    },
    addNote(transfer) {
      this.selectedPsk = transfer;
      this.note = transfer.message;
      this.changeNote = true;
    },
    addExpirationDate(transfer) {
      this.selectedPsk = transfer;
      this.expirationDate = transfer.expiration_date || '';
      this.changeExpirationDate = true;
    },
    loadPsk(overdracht) {
      this.selectedPsk = overdracht;
      this.pskFormToggle = true;
    },
    download(intake, file) {
      this.sdk.getIntakeFile(intake, file);
    },
    getPskList(newSearch) {
      if (!this.pskMailModal) {
        this.transfers = null;
      }
      if (newSearch) {
        this.currentPage = 0;
      }
      this.getGroups();
      this.sdk.getPskList((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.results.length; i += 1) {
            response.data.results[i].files = JSON.parse(response.data.results[i].files);
          }
          this.transfers = response.data.results;
          this.totalTransfers = response.data.totalRows;
        } else {
          this.transfers = [];
        }
      }, this.filterBuilder(true), this.currentPage, this.maxPerPage);
    },
    savePskNote(transfer) {
      this.sdk.savePskNote(transfer.intake, transfer.psk_index, this.note, (response) => {
        if (response.status === 200) {
          this.changeNote = false;
          this.getPskList();
        } else {
          // saving note failed
        }
      });
    },
    savePskExpirationDate(transfer) {
      this.sdk.savePskExpirationDate(
        transfer.intake,
        transfer.psk_index,
        this.expirationDate,
        (response) => {
          if (response.status === 200) {
            this.changeExpirationDate = false;
            this.getPskList();
          } else {
            // saving note failed
          }
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.filters {
  width: 100%;
  height: 0;
  transition: height 0.15s;
  background-color: $color-highlight;
  border-radius: 0;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0;
  &.active {
    height: 66px;
  }
  .filters-inner {
    width: 100%;
    height: 66px;
    padding: 2px;
    box-sizing: border-box;
    .input {
      width: calc(100% / 5);
      height: 60px;
      padding: 4px 0 0 2px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      vertical-align: top;
      span {
        padding-left: 3px;
        font-weight: bold;
      }
      input {
        border-radius: 0;
        width: 100% !important;
        height: 36px;
        vertical-align: top;
        width: calc(calc(100% / 5) - 2px);
        &:focus {
          box-shadow: none;
        }
      }
      &.buttons {
        flex-direction: row;
        align-items: flex-end;
        float: right;
        button {
          width: calc(50% - 1px);
          height: 36px;
          border-radius: 0;
          background-color: rgba(0,0,0, 0.1);
          &:hover {
            background-color: rgba(0,0,0, 0.2);
          }
        }
      }
      .userIdInput {
        width: auto !important;
        display: inline-block;
        vertical-align: top;
      }
    }
    .triple-filter {
      margin-left: 5px;
      width: calc(100% / 3);
      height: 60px;
      padding: 4px 0 0 2px;
      font-size: 13px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      .triple-name {
        padding-left: 3px;
        font-weight: bold;
      }
      .triple-filter-holder {
        overflow: hidden;
        height: 36px;
        width: 100%;
        cursor: pointer;
        div {
          width: calc(100% / 3);
          height: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.1);
          &:hover,
          &.active {
            background-color: rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }
}
.concat {
  max-width: 175px;
  display: inline-block;
}
.dropdown-list {
  top: 36px;
}
.info {
  svg {
    margin: 0px 2px;
    cursor: help;
  }
}
.help {
  cursor: help;
}
.dropdown-button,
.search-button {
  border-radius: 0;
  float: left;
}
// chrome fix
input[type=checkbox] {
  width: initial;
}
.searchbar {
  margin-left: 2px;
  &:focus {
    box-shadow: none;
  }
}
.filter-dropdown {
  padding: 10px;
}
.noresults {
  width: 100%;
  height: auto;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
  }
}

.multi-dropdown {
  width: 120px;
  margin: 0;
  display: inline-block;
  vertical-align: top;
  width: auto !important;
  .checkbox-green {
    color: #59b300;
  }
  button {
    border-radius: 0;
    margin-left: 2px !important;
  }
  .dropdown-button {
    margin-left: 3px;
    width: auto;
    padding: 0 10px;
  }
  .dropdown-list {
    width: auto;
    right: 0;
    top: 36px;
    li {
      display: flex;
      align-items: center;
      padding-left: 15px;
      position: relative;
      user-select: none;
      .dropdown-checkbox {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        svg {
          font-size: 13px;
        }
      }
      span.logTypeId {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
